<template>
  <div
    class="popover"
    :class="{'popver--left':position==='left','popver--content':position==='content'}"
    v-html="message"
  >
  </div>
</template>
<script>
export default {
  props: ['message', 'position']
}
</script>
<style lang="scss">
.popover {
  display: inline-block;
  position: absolute;
  transform: translateX(-43%);
  top: px2rem(-50);
  white-space: nowrap;
  background: #35495e;
  color: #ffffff;
  padding: px2rem(10) px2rem(20);
  border-radius: px2rem(10);
  &.popver--content {
    top: px2rem(-70);
    transform: translateX(0);
  }
  &.popver--left {
    left: auto;
    right: px2rem(190);
    transform: translateX(0);
    top: px2rem(190);
    &:after {
      display: block;
      content: '';
      border-bottom: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid transparent;
      border-left: 5px solid #35495e;
      // left: 50%;
      width: 1px;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      right: -16px;
      top: 30%;
      left: auto;
      bottom: auto;
      position: absolute;
    }
  }
  &:after {
    display: block;
    content: '';
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #35495e;
    left: 50%;
    width: 1px;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    bottom: -5px;
    position: absolute;
  }
}
</style>
